<div mat-dialog-title>
  <div class="d-flex justify-content-between">
      Enable Similar Project
      <i class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
  </div>
</div>
<div mat-dialog-content>
  <form [formGroup]="projectForm" autocomplete="off">
      <div class="row m-0 eip-pt-20">
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <edms-autocomplete [data]="projectList" [form]="projectForm" controlName="Fromproject" textField="projCodeDesc" label="From Project" error="Select project" (optionSelected)="FromProjectChange($event)" [value]="selectedFromProject">
              </edms-autocomplete>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <edms-autocomplete [data]="FrombusinessGroups" [form]="projectForm" controlName="FrombusinessGroup" textField="group_Name" label="From Business Group" error="Please select from business group">
              </edms-autocomplete>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <edms-autocomplete [data]="projectList" [form]="projectForm" controlName="Toproject" textField="projCodeDesc" label="To Project" error="Select project" (optionSelected)="ToProjectchange($event)">
              </edms-autocomplete>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <edms-autocomplete [data]="TobusinessGroups" [form]="projectForm" controlName="TobusinessGroup" textField="group_Name" label="To Business Group" error="Please select to business group">
              </edms-autocomplete>
          </div>
      </div>
  </form>
</div>
<div mat-dialog-actions>
  <div class="row justify-content-end flex-grow-1">
      <button (click)="saveProject()" class="btn btn-primary" [disabled]="!projectForm.valid" type="submit" id="btnEDMSave"><i class="fa fa-save" aria-hidden="true" id="btnCopy"></i>&nbsp;&nbsp;{{actionButtonText}}</button>&nbsp;
      <button (click)="closeDialog()" class="btn btn-secondary" id="btnEDMCancel"><i class="fa fa-cancel" aria-hidden="true" id="btnCopy1"></i>&nbsp;&nbsp;Cancel</button>
  </div>
</div>